// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 50 ? "6ba931e5" : chunkId) + "." + {"50":"09ec5d1fba44311e2bb5","88":"49c96f70bfcdb590a239","224":"a1e2f6c7a7a7149c4657","943":"81473f2fb48d86782b0b","945":"8c016e06ed179e2f4a43"}[chunkId] + ".js";
};